function sanitizeInput(input) {
    // This regex allows letters, numbers, spaces, and underscores only
    return input.replace(/[^\w\s]/gi, '');
  }  
export default sanitizeInput;